import * as React from 'react';
import React__default, { useReducer, useMemo, useEffect, useState, useCallback } from 'react';
import classnames from 'classnames';
import { Location } from '@grandvision/api-client';
import { Util, Button, RichTextArea, RadioButton, Tooltip } from '@grandvision/common';
import { Container, Heading, TextArea as TextArea$1 } from '@grandvision/elements';
import { Icon } from '@grandvision/icons';
import { useIntl, useApiConfig } from '@grandvision/state';
import { subDays, addDays, getMonth, getYear, isValid } from 'date-fns';
import { DateUtils, createScriptTag, injectTags } from '@grandvision/utils';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var Suggestions = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.items, items = _c === void 0 ? [] : _c, onClick = _a.onClick;
    return (React__default.createElement("ul", { className: "suggestions " + className, "aria-live": "polite" }, items.map(function (item) { return (React__default.createElement("li", { role: "button", tabIndex: 0, key: item.id, className: "suggestions__item", onClick: function () { return onClick(item); }, onKeyUp: function (e) { return (e.keyCode === 13 || e.keyCode === 32) && onClick(item); } }, item.label)); })));
};

var getPlacePredictions = function (place, url) { return __awaiter(void 0, void 0, void 0, function () {
    var places;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Location.getPlacePredictions(url, { place: place })];
            case 1:
                places = (_a.sent()).places;
                return [2 /*return*/, places.map(function (place, index) {
                        var _a = __read(place, 2), primaryText = _a[0], secondaryText = _a[1];
                        return {
                            id: index.toString(),
                            label: primaryText + " " + secondaryText,
                        };
                    })];
        }
    });
}); };
var regHex = /#([a-f0-9]{3}){1,2}\b/i;
var regPresetBg = /black|grey|white/;
var BookAppointment = function (_a) {
    var link = _a.link, inputField = _a.inputField, title = _a.title, _b = _a.items, items = _b === void 0 ? [] : _b, isLocationEnabled = _a.isLocationEnabled, isPlacePredictionsEnabled = _a.isPlacePredictionsEnabled, imageUrl = _a.imageUrl, text = _a.text, backgroundColor = _a.backgroundColor;
    var getLabel = useIntl().getLabel;
    var locationsUrl = useApiConfig().locationsUrl;
    var _c = __read(React.useState(''), 2), inputValue = _c[0], setInputValue = _c[1];
    var _d = __read(React.useState(items), 2), predictions = _d[0], setPredictions = _d[1];
    var _e = __read(React.useState(false), 2), useLocation = _e[0], setUseLocation = _e[1];
    var _f = __read(React.useState(false), 2), showPredictions = _f[0], setShowPredictions = _f[1];
    var ref = React.useRef(null);
    var onClickGps = React.useCallback(function () {
        setUseLocation(function (useLocation) { return !useLocation; });
        setPredictions([]);
    }, []);
    var onClickSuggestion = React.useCallback(function (item) {
        setInputValue(item.label);
        setShowPredictions(false);
    }, []);
    var onChange = React.useCallback(function (input) {
        setInputValue(input.currentTarget.value);
    }, []);
    var onFocus = React.useCallback(function () {
        setShowPredictions(true);
    }, []);
    var onBlur = React.useCallback(function (event) {
        var _a;
        if (event.relatedTarget && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            return;
        }
        setShowPredictions(false);
    }, []);
    React.useEffect(function () {
        if (!isPlacePredictionsEnabled) {
            return;
        }
        if (inputValue.length < 3) {
            setPredictions([]);
            return;
        }
        var current = true;
        var timeout = setTimeout(function () {
            if (current) {
                getPlacePredictions(inputValue, locationsUrl)
                    .then(function (result) { return current && setPredictions(result); })
                    .catch(function (err) { return console.error(err); });
            }
        }, 400);
        return function () {
            current = false;
            clearTimeout(timeout);
        };
    }, [inputValue, isPlacePredictionsEnabled, locationsUrl]);
    React.useEffect(function () {
        if (useLocation) {
            setInputValue('');
        }
    }, [useLocation]);
    var extended = !!imageUrl && !!text;
    var extendedBookAppointmentStyle = backgroundColor
        ? {
            backgroundColor: regHex.test(backgroundColor)
                ? backgroundColor
                : regPresetBg.test(backgroundColor)
                    ? Util.colorHexMap[backgroundColor]
                    : 'transparent',
        }
        : {};
    return (React.createElement(Container, { className: classnames('book-appointment-container', {
            'book-appointment-container--extended': extended,
        }) },
        extended && imageUrl && React.createElement("img", { className: "book-appointment-image", src: imageUrl }),
        React.createElement("div", { className: "book-appointment", style: extendedBookAppointmentStyle },
            React.createElement(Heading, { variant: "small", className: classnames('book-appointment__title', {
                    'book-appointment__title--extended': extended,
                }) }, title),
            React.createElement("div", { className: "book-appointment__input", ref: ref, onBlur: onBlur },
                React.createElement("input", { id: inputField.id, type: inputField.type, value: inputValue, onChange: onChange, onFocus: onFocus, className: "form-control__input", disabled: useLocation, placeholder: useLocation ? getLabel('stores.actions.useMyLocation') : inputField.placeholder }),
                isLocationEnabled && (React.createElement("button", { className: classnames('book-appointment__use-gps', {
                        'book-appointment__use-gps--active': useLocation,
                    }), "aria-label": getLabel('stores.actions.useMyLocation'), onClick: onClickGps },
                    React.createElement(Icon, { name: "gps" }))),
                isPlacePredictionsEnabled && (React.createElement("div", { className: "book-appointment__suggestions-container", "data-t": "suggestions-container" }, showPredictions && (React.createElement(Suggestions, { className: classnames('book-appointment__suggestions', {
                        _is_active: predictions.length > 0,
                    }), items: predictions, onClick: onClickSuggestion }))))),
            React.createElement(Button, { className: "book-appointment__button", caption: link.label, color: link.style || 'primary', href: getHref() }),
            extended && text && (React.createElement("div", { className: "book-appointment__content" },
                React.createElement(RichTextArea, { content: text }))))));
    function getHref() {
        var url = "" + link.url + (link.url.includes('?') ? '&' : '?');
        if (useLocation && inputValue === '') {
            return url + "userLocation=true";
        }
        return url + "search=" + encodeURIComponent(inputValue);
    }
};

/**
 * Substracts number of {days} from the provided {date}
 *
 * @example
 *   const minDate = createMinDate(new Date(), 5)
 *   <DatePicker minDate={minDate} />
 */
var createMinDate = function (date, days) {
    return date instanceof Date && typeof days === 'number' ? subDays(date, days) : undefined;
};
/**
 * Add number of {days} to the provided {date}
 *
 * @example
 *   const maxDate = createMaxDate(new Date(), 10)
 *   <DatePicker maxDate={maxDate} />
 */
var createMaxDate = function (date, days) {
    return date instanceof Date && typeof days === 'number' ? addDays(date, days) : undefined;
};

var getValuesFromState = function (state) {
    return Object.entries(state).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), fieldName = _c[0], fieldState = _c[1];
        return Object.assign(result, (_b = {},
            _b[fieldName] = fieldState ? fieldState.value : '',
            _b));
    }, {});
};
var getValidityFromState = function (state) {
    for (var field in state) {
        if (state.hasOwnProperty(field)) {
            var fieldState = state[field];
            if (fieldState && !fieldState.readonly && fieldState.isValid === false) {
                return false;
            }
        }
    }
    return true;
};
var getValuesFromComposedState = function (composedState) {
    return Object.entries(composedState).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], state = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = getValuesFromState(state), _b)));
    }, {});
};
var isValidComposedState = function (state) {
    return Object.values(state).every(getValidityFromState);
};

/**
 * Marks all the invalid fields in a form as touched.
 */
function markFormFieldsTouched(form) {
    return Object.entries(form).reduce(function (prev, _a) {
        var _b, _c;
        var _d = __read(_a, 2), field = _d[0], valueState = _d[1];
        if (!valueState) {
            return prev;
        }
        if (valueState.isValid) {
            return __assign(__assign({}, prev), (_b = {}, _b[field] = valueState, _b));
        }
        return __assign(__assign({}, prev), (_c = {}, _c[field] = __assign(__assign({}, valueState), { isTouched: true }), _c));
    }, {});
}

var objectToFormState = function (data) {
    return Object.entries(data).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), formKey = _c[0], pairs = _c[1];
        if (!pairs) {
            return {};
        }
        var newFormState = Object.entries(pairs).reduce(function (formValueState, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            return typeof value !== 'undefined'
                ? __assign(__assign({}, formValueState), (_b = {}, _b[key] = { name: key, value: value, isTouched: false }, _b)) : formValueState;
        }, {});
        return __assign(__assign({}, acc), (_b = {}, _b[formKey] = __assign(__assign({}, acc[formKey]), { formName: formKey, formValid: false, formState: __assign(__assign({}, (acc[formKey] || {}).formState), newFormState) }), _b));
    }, {});
};
var fieldsToFormState = function (data, defaults) {
    return Object.entries(data).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), name = _c[0], value = _c[1];
        return (__assign(__assign({}, result), (_b = {}, _b[name] = __assign({ name: name, value: String(value), isTouched: false }, defaults), _b)));
    }, {});
};

/*
  Helper function to create SelectOptions from an array of labels
 */
var createSimpleSelectOptions = function (labels) {
    return labels.reduce(function (result, label) {
        result[label] = { label: label, value: label };
        return result;
    }, {});
};

/**
 * Helper function to convert an array of objects in to an object that is
 * formatted correctly for the Select component
 * @param arr - Array of objects that will be turned into an object of objects
 * @param key - string that is used as key to lookup the value that will be used as labels(keys) in the returned object
 */
function createSelectOptions(arr, key) {
    if (arr === void 0) { arr = []; }
    return arr.reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[String(curr[key])] = curr, _a)));
    }, {});
}

/**
 * Merges two ComposedFormValueState objects. When a field occurs in the same
 * part in both composed states, the field's state from `b` is used.
 */
var mergeComposedFormValueState = function (a, b) {
    return Object.entries(b).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), partKey = _c[0], partState = _c[1];
        return (__assign(__assign({}, result), (_b = {}, _b[partKey] = __assign(__assign({}, result[partKey]), partState), _b)));
    }, __assign({}, a));
};

var REGEX = {
    EMAIL_ADDRESS: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    TEXT: /^[a-zA-Z\u00C0-\u00ff .-]*$/,
    ALPHANUMERIC: /\w*[a-zA-Z ][0-9]*[ .-]*$/,
    CONTAINS_DOT: /\.+/,
    BE: /^(?:(?:[1-9])(?:\d{3}))$/,
    NL: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
    GB: /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i,
    IT: /^\d{5}$/,
    DK: /^(?:[1-24-9]\d{3}|3[0-8]\d{2})$/,
    SE: /^\d{3}\s?\d{2}/,
    PT: /^\d{4}-\d{3}$/,
    IE: /^\d$/,
    IO: /^.*$/,
    ES: /^\d{5}$/,
    FR: /^(0[1-9]|[1-8]\d|9[0-5])\d{2,3}$/,
};
var DATES_RANGE = {
    DAY: {
        min: 1,
        max: 31,
    },
    MONTH: {
        min: 1,
        max: 12,
    },
    YEAR_OF_BIRTH: {
        min: 1900,
        get max() {
            return new Date().getFullYear();
        },
    },
};
var isRequired = function (value) {
    return value !== '';
};
var getPostalCodeRegex = function (country) { return REGEX[country]; };
var isValidPostalCodeForCountry = function (country, postalCode) {
    var regex = getPostalCodeRegex(country);
    return regex !== undefined && regex.test(postalCode);
};
var isNumber = function (value) {
    var parsed = parseFloat(value);
    return !isNaN(parsed) && isFinite(parsed);
};
var isInteger = function (value) {
    var parsed = parseInt(value);
    return Number.isInteger(parsed);
};
var isPositiveInteger = function (value) {
    return isInteger(value) && Number(value) > 0;
};
var isNotDecimalNumber = function (value) {
    return !REGEX.CONTAINS_DOT.test(value) && isPositiveInteger(value);
};
var isText = function (value) {
    return REGEX.TEXT.test(value);
};
var isAlphanumeric = function (value) {
    return REGEX.ALPHANUMERIC.test(value);
};
var isEmailAddress = function (value) {
    return REGEX.EMAIL_ADDRESS.test(value);
};
var isInRange = function (value, from, to) {
    return value >= from && value <= to;
};
var isValidMonth = function (value) {
    return isNumber(value) && isInRange(Number(value), DATES_RANGE.MONTH.min, DATES_RANGE.MONTH.max);
};
var isValidDay = function (value) {
    return isNumber(value) && isInRange(Number(value), DATES_RANGE.DAY.min, DATES_RANGE.DAY.max);
};
var isValidBirthDateYear = function (value) {
    return (isNumber(value) &&
        isInRange(Number(value), DATES_RANGE.YEAR_OF_BIRTH.min, DATES_RANGE.YEAR_OF_BIRTH.max));
};
var isDate = function (value) {
    var date = value.split('-');
    return isValidDate(date[2], date[1], date[0]);
};
var isValidDate = function (dd, mm, yyyy) {
    var dateObject = new Date(yyyy + "/" + mm + "/" + dd);
    return !isNaN(dateObject.getTime()) && dateObject.getDate() === parseInt(dd);
};
var isValidBirthDate = function (dd, mm, yyyy) {
    return isValidDate(dd, mm, yyyy) && isValidBirthDateYear(yyyy);
};
var isOlderThan = function (ageRestriction) { return function (value) {
    var today = new Date();
    var birthDate = new Date(value.replace(/-/g, '/')); // replace '-' with '/' because safari can't take it.
    var monthsLeft = today.getMonth() - birthDate.getMonth();
    var age = today.getFullYear() - birthDate.getFullYear();
    if (monthsLeft < 0 || (monthsLeft === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age >= ageRestriction;
}; };
// Min/Max/Exact length string validators
var minLength$1 = function (minLength) { return function (value) {
    return typeof value === 'string' && value.length >= minLength;
}; };
var maxLength = function (maxLength) { return function (value) {
    return typeof value === 'string' && value.length <= maxLength;
}; };
var exactLength = function (length) { return function (value) {
    return typeof value === 'string' && value.length === length;
}; };

var validations = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DATES_RANGE: DATES_RANGE,
    isRequired: isRequired,
    getPostalCodeRegex: getPostalCodeRegex,
    isValidPostalCodeForCountry: isValidPostalCodeForCountry,
    isNumber: isNumber,
    isInteger: isInteger,
    isPositiveInteger: isPositiveInteger,
    isNotDecimalNumber: isNotDecimalNumber,
    isText: isText,
    isAlphanumeric: isAlphanumeric,
    isEmailAddress: isEmailAddress,
    isInRange: isInRange,
    isValidMonth: isValidMonth,
    isValidDay: isValidDay,
    isValidBirthDateYear: isValidBirthDateYear,
    isDate: isDate,
    isValidDate: isValidDate,
    isValidBirthDate: isValidBirthDate,
    isOlderThan: isOlderThan,
    minLength: minLength$1,
    maxLength: maxLength,
    exactLength: exactLength
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    validations: validations,
    createMinDate: createMinDate,
    createMaxDate: createMaxDate,
    getValuesFromState: getValuesFromState,
    getValidityFromState: getValidityFromState,
    getValuesFromComposedState: getValuesFromComposedState,
    isValidComposedState: isValidComposedState,
    markFormFieldsTouched: markFormFieldsTouched,
    objectToFormState: objectToFormState,
    fieldsToFormState: fieldsToFormState,
    createSimpleSelectOptions: createSimpleSelectOptions,
    createSelectOptions: createSelectOptions,
    mergeComposedFormValueState: mergeComposedFormValueState
});

var FormContext = React.createContext({});
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.handleState = function (cb, formControlState) {
            _this.setState(function (prevState) {
                var _a;
                var newFormState = __assign(__assign({}, prevState.formState), (_a = {}, _a[formControlState.name] = __assign({}, formControlState), _a));
                return {
                    formState: __assign({}, newFormState),
                    formValid: getValidityFromState(newFormState),
                };
            }, cb);
        };
        _this.handleChange = function () {
            _this.props.onChange && _this.props.onChange(_this.state);
        };
        _this.handleBlur = function () {
            _this.props.onBlur && _this.props.onBlur(_this.state);
        };
        _this.handleSubmit = function (e) {
            var _a = _this.props, onSubmit = _a.onSubmit, _b = _a.showErrorsOnInvalidSubmit, showErrorsOnInvalidSubmit = _b === void 0 ? true : _b;
            if (e) {
                e.preventDefault();
            }
            if (showErrorsOnInvalidSubmit && !_this.state.formValid) {
                return _this.setState({
                    formState: markFormFieldsTouched(_this.state.formState),
                });
            }
            onSubmit && onSubmit(_this.state);
        };
        _this.onBlur = _this.handleState.bind(_this, _this.handleBlur);
        _this.onChange = _this.handleState.bind(_this, _this.handleChange);
        _this.onSubmit = _this.handleState.bind(_this, _this.handleSubmit);
        _this.getInitialState = function (key) { return _this.state.formState[key]; };
        _this.state = {
            formName: props.name,
            formState: props.initialFormState || {},
            formValid: false,
        };
        return _this;
    }
    Form.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.initialFormState && nextProps.initialFormState !== this.props.initialFormState) {
            this.setState({
                formState: nextProps.initialFormState,
            });
        }
    };
    Form.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? 'form' : _b, name = _a.name, dataT = _a["data-t"], _c = _a.showRequiredAndOptionalLabels, showRequiredAndOptionalLabels = _c === void 0 ? true : _c;
        var context = {
            name: name,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onSubmit: this.onSubmit,
            getInitialState: this.getInitialState,
            showRequiredAndOptionalLabels: showRequiredAndOptionalLabels,
        };
        return (React.createElement(FormContext.Provider, { value: context },
            React.createElement("form", { id: name, className: className, "data-t": dataT || name, "aria-label": this.props['aria-label'], onSubmit: this.handleSubmit, noValidate: true }, this.props.children)));
    };
    return Form;
}(React.Component));

var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.initialValue,
            isTouched: false,
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            if (value !== _this.state.value) {
                _this.setState({ value: value });
            }
            event.preventDefault();
        };
        _this.onChange = function () {
            if (_this.props.onChange) {
                _this.props.onChange(_this.state);
            }
        };
        _this.handleBlur = function () {
            if (!_this.state.isTouched) {
                _this.setState({ isTouched: true }, _this.onBlur);
            }
            else {
                _this.onBlur();
            }
        };
        _this.onBlur = function () {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.state);
            }
        };
        return _this;
    }
    Input.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({ value: this.props.initialValue || '' });
        }
        if (prevState.value !== this.state.value) {
            this.onChange();
        }
    };
    Input.prototype.render = function () {
        var _a = this.props, type = _a.type, placeholder = _a.placeholder, className = _a.className, dataT = _a["data-t"], disabled = _a.disabled, id = _a.id, min = _a.min, max = _a.max, maxLength = _a.maxLength, rest = __rest(_a, ["type", "placeholder", "className", 'data-t', "disabled", "id", "min", "max", "maxLength"]);
        var value = this.state.value;
        return (React.createElement("input", { "aria-describedby": rest['aria-describedby'], "aria-invalid": rest['aria-invalid'], "aria-required": rest['aria-required'], name: id, className: className, "data-t": dataT, type: type, value: value, onChange: this.handleChange, onBlur: this.handleBlur, placeholder: placeholder, disabled: disabled, min: type === 'number' ? min : undefined, max: type === 'number' ? max : undefined, maxLength: maxLength }));
    };
    Input.defaultProps = {
        id: '',
        'data-t': '',
        type: 'text',
        placeholder: undefined,
        initialValue: '',
        disabled: false,
    };
    return Input;
}(React.Component));

var DiscountCodeForm = function (_a) {
    var onSubmit = _a.onSubmit, content = _a.content, buttonCaptionLabel = _a.buttonCaptionLabel, placeholderLabel = _a.placeholderLabel, dataT = _a["data-t"];
    var _b = __read(React.useState(''), 2), inputValue = _b[0], setInputValue = _b[1];
    var _c = __read(React.useState(false), 2), hasError = _c[0], setHasError = _c[1];
    if (!content) {
        return null;
    }
    var _d = content.inputField, type = _d.type, inputId = _d.inputId;
    var formClass = classnames('discount-code-form', {
        'discount-code-form--error': hasError,
    });
    return (React.createElement("div", { className: formClass, onAnimationEnd: formAnimationEnd },
        React.createElement(Form, { name: "discount-code", className: "discount-code-form__form", "data-t": dataT, onSubmit: handleOnSubmit },
            React.createElement(Input, { id: inputId, className: 'form-control__input discount-code-form__input', "data-t": dataT, type: type, initialValue: inputValue, placeholder: placeholderLabel, onChange: handleOnChange }),
            React.createElement(Button, { size: "custom", className: "discount-code-form__button", caption: buttonCaptionLabel, onClick: handleOnSubmit, variant: "outline" }))));
    function handleOnChange(_a) {
        var value = _a.value;
        setInputValue(value);
    }
    function handleOnSubmit() {
        if (!inputValue) {
            setHasError(true);
            return;
        }
        onSubmit(inputValue);
        setInputValue('');
    }
    function formAnimationEnd() {
        setHasError(false);
    }
};

var validate = function (value, validations) {
    if (!validations) {
        return true;
    }
    return validations.reduce(function (isValid, validator) { return validator(value) && isValid; }, true);
};
var DefaultError = React__default.memo(function (_a) {
    var message = _a.message, id = _a.id, className = _a.className;
    return (React__default.createElement("p", { id: id, className: classnames('field__error', className) }, message));
});
DefaultError.displayName = 'Memo(DefaultError)';
/*
 * <Field /> should always be used within a <Form />
 */
var Field = function (_a) {
    var children = _a.children, name = _a.name, id = _a.id, label = _a.label; _a.icon; var required = _a.required, disabled = _a.disabled, placeholder = _a.placeholder, error = _a.error, className = _a.className, validations = _a.validations, rest = __rest(_a, ["children", "name", "id", "label", "icon", "required", "disabled", "placeholder", "error", "className", "validations"]);
    var resolvedId = id || name;
    var getLabel = useIntl().getLabel;
    var context = React__default.useContext(FormContext);
    var state = (context.getInitialState && context.getInitialState(name)) || {
        name: name,
        value: '',
    };
    var deps = [state.value, state.isValid, state.isTouched];
    var handleChange = React__default.useCallback(function (value) {
        if (state.readonly) {
            return;
        }
        var updatedState = __assign(__assign({}, state), { value: value, isValid: validate(value, validations) });
        context.onChange && context.onChange(updatedState);
        rest.onChange && rest.onChange(updatedState);
    }, __spread(deps, [validations, context.onChange, rest.onChange]));
    var handleBlur = React__default.useCallback(function (value) {
        if (state.readonly) {
            return;
        }
        var updatedState = __assign(__assign({}, state), { value: value, isTouched: true });
        context.onBlur && context.onBlur(updatedState);
        rest.onBlur && rest.onBlur(updatedState);
    }, __spread(deps, [context.onBlur, rest.onBlur]));
    // To validate initial state value from context, on initial render and a change of validations
    React__default.useEffect(function () {
        if (!context.onChange) {
            return;
        }
        var newValidationResult = validate(state.value, validations);
        // if the result of the validation of the value is the same as in context, skip update
        if (state.isValid !== newValidationResult) {
            context.onChange(__assign(__assign({}, state), { isValid: newValidationResult }));
        }
    }, [validations, state.value, state.isValid, context.onChange]);
    var isValid = state.isValid, isTouched = state.isTouched, readonly = state.readonly;
    var shouldDisplayValid = isValid === true && isTouched === true && state.value !== '' && !readonly;
    var shouldDisplayError = isValid === false && isTouched === true && !readonly;
    var childClasses = classnames({
        _is_valid: shouldDisplayValid,
        _has_error: shouldDisplayError,
    });
    var showRequiredAndOptionalLabels = context.showRequiredAndOptionalLabels;
    var displayRequiredLabel = showRequiredAndOptionalLabels && required;
    var displayOptionalLabel = showRequiredAndOptionalLabels && !required;
    var errorContent = React__default.useMemo(function () {
        return typeof error === 'string'
            ? shouldDisplayError && React__default.createElement(DefaultError, { id: resolvedId + "_error", message: error })
            : error(shouldDisplayError);
    }, [shouldDisplayError, resolvedId, error]);
    return (React__default.createElement("div", { className: classnames('field', className) },
        React__default.createElement("div", { className: "field__label-wrapper" },
            React__default.createElement("label", { htmlFor: resolvedId, className: "field__label" },
                label,
                displayRequiredLabel && React__default.createElement("span", { className: "field__required-asterisk" }, "*")),
            displayOptionalLabel && (React__default.createElement("small", { className: "field__optional-tag" }, getLabel('common.optional')))),
        React__default.createElement("div", { className: "field__content" }, React__default.Children.map(children, function (child) {
            return React__default.cloneElement(child, {
                name: name,
                id: resolvedId,
                value: state.value,
                onChange: handleChange,
                onBlur: handleBlur,
                className: childClasses,
                required: required,
                disabled: disabled,
                placeholder: placeholder,
            });
        })),
        errorContent));
};

var CounterFooter = function (_a) {
    var count = _a.count, errorMessage = _a.errorMessage, id = _a.id, showError = _a.showError;
    var getFormattedLabel = useIntl().getFormattedLabel;
    return (React__default.createElement("div", { className: "textarea-component__message" },
        showError && (React__default.createElement(DefaultError, { id: id + "_error", className: "textarea-component__error", message: errorMessage })),
        count !== null && (React__default.createElement("p", { id: id + "_count", "aria-label": getFormattedLabel('fields.textarea.charactersRemaining', {
                labelData: {
                    amount: count,
                },
            }), className: classnames('textarea-component__count', {
                'textarea-component__count--error': count < 1,
            }) }, count))));
};
CounterFooter.displayName = 'CounterFooter';
var TextArea = function (_a) {
    var errorMessage = _a.errorMessage, name = _a.name, id = _a.id, label = _a.label, placeholder = _a.placeholder, maxLength = _a.maxLength, validations = _a.validations, required = _a.required, disabled = _a.disabled, className = _a.className, testId = _a["data-t"], rest = __rest(_a, ["errorMessage", "name", "id", "label", "placeholder", "maxLength", "validations", "required", "disabled", "className", 'data-t']);
    var resolvedId = id || name;
    var initialCount = maxLength ? maxLength : null;
    var _b = __read(React__default.useState(initialCount), 2), count = _b[0], setCount = _b[1];
    var handleEvent = React__default.useCallback(function (state) {
        maxLength && setCount(maxLength - state.value.length);
    }, [maxLength]);
    var renderError = function (showError) { return (React__default.createElement(CounterFooter, { id: resolvedId, count: count, errorMessage: errorMessage, showError: showError })); };
    return (React__default.createElement(Field, __assign({}, rest, { name: name, id: resolvedId, label: label, className: classnames('textarea-component', className), required: required, disabled: disabled, placeholder: placeholder, validations: validations, error: renderError, onChange: handleEvent, onBlur: handleEvent }),
        React__default.createElement(TextArea$1, { name: name, maxLength: maxLength, "aria-describedby": resolvedId + "_error " + resolvedId + "_count", "data-t": testId })));
};

var ComposedFormContext = React.createContext({});
var ComposedForm = function (props) {
    var _a = __read(React.useState(props.initialFormState), 2), formState = _a[0], setFormState = _a[1];
    var state = React.useMemo(function () { return ({
        formName: props.name,
        formState: formState || {},
        formValid: !!formState && isValidComposedState(formState),
    }); }, [props.name, formState]);
    // This effect calls onChange whenever `state` changes
    React.useEffect(function () { return props.onChange && props.onChange(state); }, [state]);
    // This effect resets state when `initialFormState` changes
    // NOTE: this uses useLayoutEffect to work around a race condition with DateOfBirthSelect's initial onChange
    React.useLayoutEffect(function () { return setFormState(props.initialFormState); }, [props.initialFormState]);
    // These callbacks are used by form Parts to get and update their part of `formState`
    var composedContext = {
        formName: props.name,
        onChange: React.useCallback(function (name, controlState) {
            setFormState(function (current) {
                var _a, _b;
                return (__assign(__assign({}, current), (_a = {}, _a[name] = __assign(__assign({}, (current && current[name])), (_b = {}, _b[controlState.name] = controlState, _b)), _a)));
            });
        }, []),
        getInitialState: React.useCallback(function (name) { return formState && formState[name]; }, [formState]),
    };
    // The native form's onSubmit is intercepted and the current `state` added
    var handleFormSubmit = React.useCallback(function (ev) {
        ev && ev.preventDefault(); // this behavior is to remain consistent with Form
        props.onSubmit && props.onSubmit(state);
    }, [props.name, props.onSubmit, state]);
    return (React.createElement(ComposedFormContext.Provider, { value: composedContext },
        React.createElement("form", { noValidate: true, id: props.name, className: props.className, "data-t": props['data-t'] || props.name, onSubmit: handleFormSubmit, children: props.children })));
};
var Part = function (_a) {
    var name = _a.name, children = _a.children;
    var _b = React.useContext(ComposedFormContext), formName = _b.formName, onChange = _b.onChange, getInitialState = _b.getInitialState;
    !onChange && console.error('ComposedForm.Part cannot be used outside of a ComposedForm');
    // These callbacks for the regular FormContext act as a proxy to add this
    // Part's `name` to get and update the correct part of ComposedForm's state
    var formContext = {
        name: formName,
        onChange: React.useCallback(function (state) { return onChange && onChange(name, state); }, [name, onChange]),
        getInitialState: React.useCallback(function (fieldName) { return ((getInitialState && getInitialState(name)) || {})[fieldName]; }, [getInitialState]),
    };
    return React.createElement(FormContext.Provider, { value: formContext, children: children });
};
ComposedForm.Part = Part;

var RadioButtons = /** @class */ (function (_super) {
    __extends(RadioButtons, _super);
    function RadioButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            name: _this.props.scope,
            value: _this.props.initialValue,
            required: !!_this.props.initialValue === false,
            isTouched: false,
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            var updatedState = __assign(__assign({}, _this.state), { value: value });
            _this.setState(updatedState);
            _this.props.onChange && _this.props.onChange(updatedState);
        };
        return _this;
    }
    RadioButtons.prototype.componentDidUpdate = function (prevProps) {
        var previousValue = prevProps.initialValue && prevProps.initialValue;
        var value = this.props.initialValue;
        if (value !== previousValue) {
            this.setState({
                value: value,
            });
        }
    };
    RadioButtons.prototype.componentDidMount = function () {
        this.props.onChange && this.props.onChange(this.state);
    };
    RadioButtons.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, scope = _a.scope, alignment = _a.alignment, className = _a.className, formName = _a.formName, rest = __rest(_a, ["items", "scope", "alignment", "className", "formName"]);
        var directionClass = alignment === 'horizontal' ? 'radio-buttons--horizontal' : 'radio-buttons--vertical';
        return (React.createElement("fieldset", { "data-t": rest['data-t'], className: classnames('radio-buttons', directionClass, className) }, items &&
            items.length > 0 &&
            items.map(function (item, i) {
                var inputId = (formName || 'radio-buttons') + "_" + (item.value.toString().replace(/\s/g, '-') || i);
                return (React.createElement(RadioButton, { key: item.value, id: inputId, name: scope, variant: "plain", value: String(item.value), isChecked: item.value === _this.state.value, "aria-checked": item.value === _this.state.value, disabled: item.disabled, onChange: _this.handleChange }, item.label));
            })));
    };
    RadioButtons.defaultProps = {
        items: [],
        alignment: 'horizontal',
        formName: '',
    };
    return RadioButtons;
}(React.Component));
var ConnectedRadioButtons = function (_a) {
    var onChange = _a.onChange, scope = _a.scope, rest = __rest(_a, ["onChange", "scope"]);
    return (React.createElement(FormContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        var value = rest.initialValue || '';
        if (context.getInitialState && scope) {
            var fieldState = context.getInitialState(scope);
            if (fieldState) {
                value = fieldState.value;
            }
        }
        return (React.createElement(RadioButtons, __assign({}, rest, { scope: scope, formName: context.name, onChange: context.onChange || onChange, initialValue: value || (rest.initialValue && rest.initialValue) })));
    }));
};
ConnectedRadioButtons.defaultProps = __assign({}, RadioButtons.defaultProps);

// Value is empty because that way :invalid gets applied to the select when the placeholder is selected
var placeholderValue = '';
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedOptionKey: _this.props.initialState && _this.props.initialState.value,
            isTouched: _this.props.isTouched || false,
        };
        _this.onChange = function (event) {
            var key = event.currentTarget.value;
            var value = _this.props.options[key];
            _this.props.onChange && _this.props.onChange(value);
            _this.setState({ selectedOptionKey: key, isTouched: true });
        };
        _this.onFocus = function () {
            if (_this.props.selectionStart &&
                !_this.state.isTouched &&
                !(_this.props.initialState && _this.props.initialState.value)) {
                _this.props.onChange && _this.props.onChange(_this.props.options[_this.props.selectionStart]);
                _this.setState({ selectedOptionKey: _this.props.selectionStart });
            }
        };
        return _this;
    }
    Select.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var _this = this;
        return Object.entries(this.props).reduce(function (shouldUpdate, _a) {
            var _b = __read(_a, 2), propKey = _b[0], currentPropValue = _b[1];
            var nextPropValue = nextProps[propKey];
            if (propKey === 'initialState') {
                var keys = Object.keys(nextProps.initialState || {});
                return keys.reduce(function (update, k) {
                    var _a, _b;
                    return update || ((_a = nextProps.initialState) === null || _a === void 0 ? void 0 : _a[k]) === ((_b = _this.props.initialState) === null || _b === void 0 ? void 0 : _b[k]);
                }, true);
            }
            else {
                return shouldUpdate || nextPropValue === currentPropValue;
            }
        }, true);
    };
    Select.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.initialState !== this.props.initialState) {
            this.setState({
                selectedOptionKey: this.props.initialState && this.props.initialState.value,
                isTouched: this.props.initialState && this.props.initialState.isTouched,
            });
        }
    };
    Select.prototype.getOptions = function () {
        return this.props.sortOptionsBy
            ? Object.keys(this.props.options).sort(this.props.sortOptionsBy)
            : Object.keys(this.props.options);
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, id = _b.id, name = _b.name, label = _b.label, className = _b.className, placeholder = _b.placeholder, iconName = _b.iconName, disabled = _b.disabled, _c = _b.required, required = _c === void 0 ? true : _c, _d = _b.hideAsteriskSign, hideAsteriskSign = _d === void 0 ? false : _d, testId = _b["data-t"], rest = __rest(_b, ["id", "name", "label", "className", "placeholder", "iconName", "disabled", "required", "hideAsteriskSign", 'data-t']);
        return (React.createElement("div", { className: classnames('select-field', className, {
                'select-field--disabled': disabled,
            }) },
            label && (React.createElement("label", { className: "select-field__label", htmlFor: id },
                label,
                required && !hideAsteriskSign && React.createElement("span", { className: "select-field__asterisk" }, "*"))),
            React.createElement("div", { className: "select-field__select-wrapper" },
                React.createElement("select", { id: id, name: name, className: "select-field__select", "data-t": testId, onChange: this.onChange, onFocus: this.onFocus, value: (_a = this.state.selectedOptionKey) !== null && _a !== void 0 ? _a : placeholderValue, disabled: disabled, required: !!placeholder, "aria-labelledby": rest['aria-labelledby'], "aria-describedby": rest['aria-describedby'], "aria-invalid": rest['aria-invalid'] },
                    placeholder && (React.createElement("option", { "data-t": "select-placeholder", "aria-selected": "false", disabled: required, value: placeholderValue }, placeholder)),
                    this.getOptions().map(function (key) { return (React.createElement("option", { value: key, key: key, "aria-selected": _this.state.selectedOptionKey === key }, key)); })),
                React.createElement(Icon, { name: iconName || 'chevron-down', className: "select-field__icon" }))));
    };
    return Select;
}(React.Component));

var FormGroup = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? 1 : _b, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames('form-group', {
            'form-group--half': columns === 2,
            'form-group--third': columns === 3,
        }, className) }, children));
};

var isEqualState = function (a, b) {
    return a.value === b.value &&
        a.isTouched === b.isTouched &&
        a.isValid === b.isValid &&
        a.readonly === b.readonly;
};
var FormControl = /** @class */ (function (_super) {
    __extends(FormControl, _super);
    function FormControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            name: _this.props.id,
        };
        _this.onChange = function () {
            if (_this.props.onChange) {
                _this.props.onChange(__assign(__assign({}, _this.state), { isValid: FormControl.validate(_this.props.validations, _this.props.required, _this.state.value) }));
            }
        };
        _this.handleChange = function (state) {
            var value = state.value;
            if (value !== _this.state.value) {
                _this.setState({ value: value });
            }
        };
        _this.handleBlur = function (state) {
            _this.setState({ isTouched: state.isTouched });
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.state);
            }
        };
        return _this;
    }
    FormControl.getDerivedStateFromProps = function (props, state) {
        return {
            isValid: FormControl.validate(props.validations, props.required || false, state.value || '', props.maxLength),
        };
    };
    FormControl.prototype.componentDidMount = function () {
        var initialState = this.props.initialState;
        if (initialState) {
            this.setState({
                value: initialState.value || '',
                isTouched: initialState.isTouched !== undefined && initialState.isTouched,
                isValid: FormControl.validate(this.props.validations, this.props.required || false, initialState.value),
            });
            if (initialState.readonly) {
                this.setState({ readonly: true });
            }
        }
    };
    FormControl.prototype.applyInitialState = function (initialState) {
        this.setState({
            value: initialState.value || '',
            isTouched: initialState.isTouched !== undefined && initialState.isTouched,
            isValid: FormControl.validate(this.props.validations, this.props.required || false, initialState.value),
        });
    };
    FormControl.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.initialState &&
            this.props.initialState &&
            !isEqualState(prevProps.initialState, this.props.initialState)) {
            this.applyInitialState(this.props.initialState);
        }
        if (prevState.isTouched !== this.state.isTouched ||
            prevState.isValid !== this.state.isValid ||
            prevState.value !== this.state.value) {
            this.onChange();
        }
    };
    FormControl.prototype.render = function () {
        var _a = this.props, label = _a.label, id = _a.id, type = _a.type, icon = _a.icon, errorMessage = _a.errorMessage, required = _a.required, placeholder = _a.placeholder, optionalText = _a.optionalText, tooltip = _a.tooltip, initialState = _a.initialState, disabled = _a.disabled, className = _a.className, maxLength = _a.maxLength, hideAsteriskSign = _a.hideAsteriskSign, rest = __rest(_a, ["label", "id", "type", "icon", "errorMessage", "required", "placeholder", "optionalText", "tooltip", "initialState", "disabled", "className", "maxLength", "hideAsteriskSign"]);
        var _b = this.state, isValid = _b.isValid, isTouched = _b.isTouched, value = _b.value, readonly = _b.readonly;
        var displayValid = isValid === true && isTouched === true && value !== '' && !readonly;
        var displayError = isValid === false && isTouched === true && !readonly;
        var errorMessageId = id + "-error-message";
        var ariaDescribedBy = ((rest['aria-describedby'] || '') + " " + errorMessageId).trim();
        var inputClasses = classnames('form-control__input', {
            'form-control__input--with-aside': icon,
            _is_valid: displayValid,
            _is_invalid: displayError,
        });
        return (React.createElement("label", { className: classnames('form-control', className) },
            label && (React.createElement("span", { className: "form-control__label" },
                label,
                required && !hideAsteriskSign && React.createElement("span", { className: "form-control__asterisk" }, "*"),
                tooltip && React.createElement(Tooltip, { message: tooltip, id: id }))),
            !required && optionalText && (React.createElement("small", { className: "form-control__optional-tag" }, optionalText)),
            React.createElement("div", { className: "form-control__wrapper" },
                React.createElement(Input, { "aria-invalid": !isValid, "aria-required": required, "aria-describedby": ariaDescribedBy, id: id, className: inputClasses, "data-t": this.props['data-t'], type: type, initialValue: (initialState && initialState.value) || '', placeholder: placeholder, onChange: this.handleChange, onBlur: this.handleBlur, disabled: disabled || readonly, maxLength: maxLength }),
                icon && React.createElement("div", { className: "form-control__aside" }, icon)),
            errorMessage && displayError && (React.createElement("span", { id: errorMessageId, className: "form-control__error" }, errorMessage))));
    };
    FormControl.defaultProps = {
        type: 'text',
        hideAsteriskSign: false,
        required: true,
        validations: [],
        initialState: {
            value: '',
            isTouched: false,
        },
        disabled: false,
    };
    FormControl.validate = function (validations, required, value, maxLengthValue) {
        if (!required && value.length === 0) {
            return true;
        }
        if (required) {
            if (!isRequired(value)) {
                return false;
            }
        }
        if (maxLengthValue && !maxLength(maxLengthValue)(value)) {
            return false;
        }
        return validations.reduce(function (isValid, validator) { return validator(value) && isValid; }, true);
    };
    return FormControl;
}(React.Component));
var ConnectedFormControl = function (_a) {
    var onBlur = _a.onBlur, onChange = _a.onChange, rest = __rest(_a, ["onBlur", "onChange"]);
    return (React.createElement(FormContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        return (React.createElement(FormControl, __assign({}, rest, { onBlur: context.onBlur || onBlur, onChange: context.onChange || onChange, initialState: (context.getInitialState && context.getInitialState(rest.id)) ||
                (rest.initialState && rest.initialState) })));
    }));
};
ConnectedFormControl.defaultProps = __assign({}, FormControl.defaultProps);

var DateFormat;
(function (DateFormat) {
    DateFormat["dmy"] = "dmy";
    DateFormat["ymd"] = "ymd";
    DateFormat["mdy"] = "mdy";
})(DateFormat || (DateFormat = {}));

var types = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get DateFormat () { return DateFormat; }
});

var InputWithSuggestions = /** @class */ (function (_super) {
    __extends(InputWithSuggestions, _super);
    function InputWithSuggestions(props) {
        var _this = _super.call(this, props) || this;
        _this.filter = function (value, _a) {
            var label = _a.label;
            return !!value && value !== label && new RegExp(value, 'i').test(label);
        };
        _this.state = {
            items: [],
            value: undefined,
        };
        _this.onChange = function (state) {
            var _a = _this.props, items = _a.items, _b = _a.filter, filter = _b === void 0 ? _this.filter : _b, maxItems = _a.maxItems;
            _this.setState({
                value: state.value,
                items: items.filter(filter.bind(_this, state.value)).slice(0, maxItems || items.length),
            });
            if (_this.props.onChange) {
                _this.props.onChange(state);
            }
        };
        _this.onBlur = function (state) {
            if (_this.props.onBlur) {
                _this.props.onBlur(state);
            }
        };
        _this.onClickSuggestion = function (item) {
            _this.setState({
                value: item.label,
                items: [],
            }, function () {
                if (_this.props.onClickSuggestion) {
                    _this.props.onClickSuggestion(item);
                }
            });
        };
        if (props.initialValue) {
            _this.state.value = props.initialValue;
        }
        return _this;
    }
    InputWithSuggestions.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({ value: this.props.initialValue || '' });
        }
    };
    InputWithSuggestions.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inputClassName, inputClassName = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, disabled = _a.disabled;
        var _e = this.state, items = _e.items, value = _e.value;
        return (React.createElement("div", { className: "input-with-suggestions " + className },
            React.createElement(Input, { type: "text", className: "input-with-suggestions__input " + inputClassName, initialValue: value, placeholder: placeholder, onChange: this.onChange, onBlur: this.onBlur, disabled: disabled }),
            !disabled && items.length ? (React.createElement(Suggestions, { className: "input-with-suggestions__suggestions", items: items, onClick: this.onClickSuggestion })) : null));
    };
    return InputWithSuggestions;
}(React.Component));

var createOptions = function (min, max) {
    var _a;
    var options = {};
    for (var i = min; i <= max; i++) {
        var value = i.toString();
        options = __assign(__assign({}, options), (_a = {}, _a[value] = value, _a));
    }
    return options;
};
var reducer = function (state, action) {
    var day = state.day, month = state.month, year = state.year, isTouched = state.isTouched;
    switch (action.type) {
        case 'day':
            return {
                day: action.payload,
                month: month,
                year: year,
                isTouched: isTouched || (!!month && !!year),
            };
        case 'month':
            return {
                day: day,
                month: action.payload,
                year: year,
                isTouched: isTouched || (!!day && !!year),
            };
        case 'year':
            return {
                day: day,
                month: month,
                year: action.payload,
                isTouched: isTouched || (!!day && !!month),
            };
        case 'reset':
            return initialize(action.payload);
        default:
            console.warn('Unknown action: ' + action);
            return state;
    }
};
var initialize = function (initialState) {
    if (initialState) {
        var _a = __read(initialState.value.split('-'), 3), year = _a[0], month = _a[1], day = _a[2];
        return {
            day: day || '',
            month: month || '',
            year: year || '',
            isTouched: initialState.isTouched || false,
        };
    }
    return { day: '', month: '', year: '', isTouched: false };
};
var DateOfBirthSelect = function (_a) {
    var _b = _a.dateFormat, dateFormat = _b === void 0 ? DateFormat.dmy : _b, minYear = _a.minYear, maxYear = _a.maxYear, dayPlaceholder = _a.dayPlaceholder, monthPlaceholder = _a.monthPlaceholder, yearPlaceholder = _a.yearPlaceholder, errorMessage = _a.errorMessage, label = _a.label, tooltipLabel = _a.tooltipLabel, onChange = _a.onChange, initialState = _a.initialState, validations = _a.validations, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.hideAsteriskSign, hideAsteriskSign = _d === void 0 ? false : _d, _e = _a.name, name = _e === void 0 ? 'customerDateOfBirth' : _e;
    var _f = __read(useReducer(reducer, initialState, initialize), 2), state = _f[0], dispatch = _f[1];
    var day = state.day, month = state.month, year = state.year, isTouched = state.isTouched;
    var readonly = initialState && initialState.readonly;
    var labelId = label + "-" + name;
    var value = useMemo(function () { return (year && month && day ? [year, month, day].join('-') : ''); }, [state]);
    var isValid = useMemo(function () { return !validations || FormControl.validate(validations, required, value); }, [validations, value]);
    useEffect(function () {
        dispatch({ type: 'reset', payload: initialState });
    }, [initialState && initialState.value, initialState && initialState.isTouched]);
    useEffect(function () {
        onChange &&
            onChange(__assign({ name: name,
                value: value,
                isValid: isValid,
                isTouched: isTouched }, (readonly === undefined ? {} : { readonly: readonly })));
    }, [onChange, name, value, isValid, isTouched]);
    var classes = classnames({
        _is_valid: isValid && isTouched && !readonly,
        _is_invalid: !isValid && isTouched && !readonly,
    });
    var handleDayChange = React.useCallback(function (payload) {
        dispatch({ type: 'day', payload: payload });
    }, []);
    var handleMonthChange = React.useCallback(function (payload) {
        dispatch({ type: 'month', payload: payload });
    }, []);
    var handleYearChange = React.useCallback(function (payload) {
        dispatch({ type: 'year', payload: payload });
    }, []);
    // Convert dateFormat string to array
    var format = __spread(dateFormat);
    var selectionStart = React.useMemo(function () {
        if (maxYear) {
            return String(maxYear);
        }
        if (minYear) {
            return String(minYear);
        }
        return String(new Date().getFullYear() - 18);
    }, [minYear, maxYear]);
    var selectInputs = {
        d: React.useMemo(function () { return (React.createElement(Select, { className: classes, id: "day-" + name, name: "day", key: "day-" + name, placeholder: dayPlaceholder, options: createOptions(DATES_RANGE.DAY.min, DATES_RANGE.DAY.max), onChange: handleDayChange, initialState: { value: day }, disabled: readonly, "aria-labelledby": labelId })); }, [
            classes,
            name,
            dayPlaceholder,
            createOptions,
            DATES_RANGE.DAY.min,
            DATES_RANGE.DAY.max,
            day,
            readonly,
        ]),
        m: React.useMemo(function () { return (React.createElement(Select, { className: classes, id: "month-" + name, name: "month", key: "month-" + name, placeholder: monthPlaceholder, options: createOptions(DATES_RANGE.MONTH.min, DATES_RANGE.MONTH.max), onChange: handleMonthChange, initialState: { value: month }, disabled: readonly, "aria-labelledby": labelId })); }, [
            classes,
            name,
            monthPlaceholder,
            createOptions,
            DATES_RANGE.MONTH.min,
            DATES_RANGE.MONTH.max,
            month,
            readonly,
        ]),
        y: React.useMemo(function () { return (React.createElement(Select, { className: classes, id: "year-" + name, name: "year", key: "year-" + name, placeholder: yearPlaceholder, options: createOptions(minYear !== null && minYear !== void 0 ? minYear : DATES_RANGE.YEAR_OF_BIRTH.min, maxYear !== null && maxYear !== void 0 ? maxYear : DATES_RANGE.YEAR_OF_BIRTH.max), onChange: handleYearChange, initialState: { value: year }, disabled: readonly, selectionStart: selectionStart, sortOptionsBy: function (a, b) {
                return b.localeCompare(a, 'en', { sensitivity: 'base', usage: 'sort' });
            }, "aria-labelledby": labelId })); }, [
            classes,
            name,
            yearPlaceholder,
            createOptions,
            minYear,
            maxYear,
            DATES_RANGE.YEAR_OF_BIRTH.min,
            DATES_RANGE.YEAR_OF_BIRTH.max,
            year,
            readonly,
        ]),
    };
    return (React.createElement("div", { className: "form-control date-of-birth-select" },
        label && (React.createElement("div", { className: "form-control__label" },
            React.createElement("span", { id: labelId }, label),
            required && !hideAsteriskSign && React.createElement("span", { className: "form-control__asterisk" }, "*"),
            tooltipLabel && React.createElement(Tooltip, { id: name + "-tooltip", message: tooltipLabel }))),
        React.createElement("div", { className: "date-of-birth-select__container" }, format.map(function (entry) { return selectInputs[entry]; })),
        !isValid && isTouched && React.createElement("div", { className: "form-control__error" }, errorMessage)));
};
var MemoizedDateOfBirthSelect = React.memo(DateOfBirthSelect);
MemoizedDateOfBirthSelect.displayName = 'DateOfBirthSelect';
var ConnectedDateOfBirthSelect = function (props) { return (React.createElement(FormContext.Consumer, null, function (context) {
    if (context === void 0) { context = {}; }
    return (React.createElement(MemoizedDateOfBirthSelect, __assign({}, props, { onChange: context.onChange || props.onChange, initialState: (context.getInitialState &&
            context.getInitialState(props.name || 'customerDateOfBirth')) ||
            props.initialState })));
})); };
ConnectedDateOfBirthSelect.defaultProps = __assign({}, DateOfBirthSelect.defaultProps);

var PrefixSelect = function (_a) {
    var errorMessage = _a.errorMessage, label = _a.label, tooltipLabel = _a.tooltipLabel, _b = _a.placeholder, placeholder = _b === void 0 ? 'Prefix' : _b, onChange = _a.onChange, options = _a.options, initialState = _a.initialState, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.hideAsteriskSign, hideAsteriskSign = _d === void 0 ? false : _d, _e = _a.name, name = _e === void 0 ? 'salutation' : _e;
    var _f = __read(useState((initialState && initialState.value) || ''), 2), value = _f[0], setValue = _f[1];
    var _g = __read(useState((initialState && initialState.isTouched) || false), 2), isTouched = _g[0], setIsTouched = _g[1];
    var isValid = useMemo(function () { return FormControl.validate([], required, value); }, [value, required]);
    var readonly = initialState && initialState.readonly;
    React.useEffect(function () {
        onChange &&
            onChange(__assign({ value: value,
                name: name,
                isValid: isValid,
                isTouched: isTouched }, (readonly === undefined ? {} : { readonly: readonly })));
    }, [onChange, value, name, isValid, isTouched]);
    React.useEffect(function () {
        setValue((initialState === null || initialState === void 0 ? void 0 : initialState.value) || '');
        setIsTouched((initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || false);
    }, [initialState === null || initialState === void 0 ? void 0 : initialState.value, initialState === null || initialState === void 0 ? void 0 : initialState.isTouched]);
    var handleChange = useCallback(function (option) {
        setValue(option.label);
        setIsTouched(true);
    }, [required]);
    var classes = classnames('prefix-select__input', {
        _is_valid: isValid && isTouched && !readonly,
        _is_invalid: !isValid && isTouched && !readonly,
    });
    return (React.createElement("label", { className: "form-control prefix-select" },
        label && (React.createElement("div", { className: "form-control__label" },
            label,
            required && !hideAsteriskSign && React.createElement("span", { className: "form-control__asterisk" }, "*"),
            tooltipLabel && React.createElement(Tooltip, { id: name + "-tooltip", message: tooltipLabel }))),
        React.createElement("div", { className: "form-control__wrapper" },
            React.createElement(Select, { className: classes, id: "salutation", name: "salutation", placeholder: placeholder, options: options, initialState: { value: value, isTouched: isTouched, isValid: isValid }, onChange: handleChange, disabled: readonly })),
        !isValid && isTouched && React.createElement("span", { className: "form-control__error" }, errorMessage)));
};
var ConnectedPrefixSelect = function (props) { return (React.createElement(FormContext.Consumer, null, function (context) {
    if (context === void 0) { context = {}; }
    return (React.createElement(PrefixSelect, __assign({}, props, { onChange: context.onChange, initialState: (context.getInitialState && context.getInitialState(props.name || 'salutation')) ||
            props.initialState })));
})); };
ConnectedPrefixSelect.defaultProps = __assign({}, PrefixSelect.defaultProps);

var MultipleAddressLine = function (_a) {
    var addLineLabel = _a.addLineLabel, label = _a.label, errorMessage = _a.errorMessage, getInitialState = _a.getInitialState, validations = _a.validations, maxLength = _a.maxLength, _b = _a.initialLineAmount, initialLineAmount = _b === void 0 ? 1 : _b, _c = _a.required, required = _c === void 0 ? true : _c, lineTwoLabel = _a.lineTwoLabel, lineThreeLabel = _a.lineThreeLabel;
    var _d = __read(useState(initialLineAmount), 2), lineAmount = _d[0], setLineAmount = _d[1];
    var additionalStreetInfoValue = getInitialState && getInitialState('additionalStreetInfo');
    var additionalAddressInfoValue = getInitialState && getInitialState('additionalAddressInfo');
    if (additionalStreetInfoValue && additionalStreetInfoValue.value && lineAmount < 2) {
        setLineAmount(2);
    }
    if (additionalAddressInfoValue && additionalAddressInfoValue.value && lineAmount < 3) {
        setLineAmount(3);
    }
    var handleClick = function () {
        setLineAmount(lineAmount + 1);
    };
    var inputs = [
        React__default.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "streetName", key: "streetName", "data-t": "streetName", label: label, initialState: getInitialState && getInitialState('streetName'), errorMessage: errorMessage, validations: validations, required: required, maxLength: maxLength })),
        React__default.createElement("div", { key: "additionalStreetInfo", "data-t": "additionalStreetInfo", className: classnames('multiple-address-line__additional-line', {
                'multiple-address-line__additional-line--hidden': lineAmount < 2,
            }) },
            React__default.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "additionalStreetInfo", key: "additionalStreetInfo", "data-t": "additionalStreetInfoFormControl", required: false, initialState: getInitialState && getInitialState('additionalStreetInfo'), errorMessage: errorMessage, validations: validations, maxLength: maxLength, label: lineTwoLabel }))),
        React__default.createElement("div", { key: "additionalAddressInfo", "data-t": "additionalAddressInfo", className: classnames('multiple-address-line__additional-line', {
                'multiple-address-line__additional-line--hidden': lineAmount < 3,
            }) },
            React__default.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { key: "additionalAddressInfo", id: "additionalAddressInfo", "data-t": "additionalAddressInfoFormControl", required: false, initialState: getInitialState && getInitialState('additionalAddressInfo'), errorMessage: errorMessage, validations: validations, maxLength: maxLength, label: lineThreeLabel }))),
    ];
    return (React__default.createElement("div", { className: "multiple-address-line" },
        inputs,
        lineAmount < inputs.length && (React__default.createElement("button", { type: "button", className: "multiple-address-line__add-lines", onClick: handleClick }, addLineLabel))));
};
var ConnectedMultipleAddressLine = function (_a) {
    var props = __rest(_a, []);
    return (React__default.createElement(FormContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        return React__default.createElement(MultipleAddressLine, __assign({}, props, { getInitialState: context.getInitialState }));
    }));
};
ConnectedMultipleAddressLine.defaultProps = __assign({}, MultipleAddressLine.defaultProps);

var ReactDatePicker = function (_a) {
    var locale = _a.locale, dateFnsLocale = _a.dateFnsLocale, props = __rest(_a, ["locale", "dateFnsLocale"]);
    var _b = __read(React__default.useState(null), 2), Module = _b[0], setModule = _b[1];
    var loadComponent = React__default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var importedModule, registerLocale;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(
                    /* webpackChunkName: 'react-datepicker' */ 'react-datepicker')];
                case 1:
                    importedModule = _a.sent();
                    registerLocale = importedModule.registerLocale;
                    registerLocale(locale, dateFnsLocale);
                    setModule(importedModule);
                    return [2 /*return*/];
            }
        });
    }); }, [locale, dateFnsLocale]);
    React__default.useEffect(function () {
        loadComponent();
    }, [loadComponent]);
    // Don't render if we didn't register the (date-fns)locale correctly
    // as we're not able to translate days/months without it
    return Module && React__default.createElement(Module.default, __assign({ locale: locale }, props));
};

var createCustomHeader = function (dateFnsLocale) {
    return function (_a) {
        var _b;
        var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
        return (React__default.createElement("div", { className: "react-datepicker__custom-nav" },
            React__default.createElement("button", { className: "react-datepicker__navigation react-datepicker__navigation--previous", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, type: "button" },
                React__default.createElement(Icon, { name: "chevron-left" })),
            React__default.createElement("div", { className: "react-datepicker__current-month" },
                ((_b = dateFnsLocale === null || dateFnsLocale === void 0 ? void 0 : dateFnsLocale.localize) === null || _b === void 0 ? void 0 : _b.month(getMonth(date))) || getMonth(date),
                " ",
                getYear(date)),
            React__default.createElement("button", { className: "react-datepicker__navigation react-datepicker__navigation--next", onClick: increaseMonth, disabled: nextMonthButtonDisabled, type: "button" },
                React__default.createElement(Icon, { name: "chevron-right" }))));
    };
};
var DatePicker = function (_a) {
    var onChange = _a.onChange, onBlur = _a.onBlur, className = _a.className, label = _a.label, tooltip = _a.tooltip, placeholder = _a.placeholder, optionalText = _a.optionalText, errorMessage = _a.errorMessage, initialValue = _a.initialValue, minDate = _a.minDate, maxDate = _a.maxDate, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'MMMM d, yyyy' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? true : _d, _e = _a.hideAsteriskSign, hideAsteriskSign = _e === void 0 ? false : _e, _f = _a.useNativeInput, useNativeInput = _f === void 0 ? false : _f, _g = _a["data-t"], testId = _g === void 0 ? 'date-picker' : _g;
    var _h = useIntl(), locale = _h.locale, dateFnsLocale = _h.dateFnsLocale;
    var _j = __read(React__default.useState(initialValue), 2), date = _j[0], setDate = _j[1];
    var _k = __read(React__default.useState(true), 2), isValid$1 = _k[0], setIsValid = _k[1];
    var _l = __read(React__default.useState(false), 2), hasFocus = _l[0], setHasFocus = _l[1];
    var _m = __read(React__default.useState(false), 2), isTouched = _m[0], setIsTouched = _m[1];
    var customHeader = React__default.useMemo(function () { return createCustomHeader(dateFnsLocale); }, [dateFnsLocale]);
    var handleBlur = React__default.useCallback(function () {
        setHasFocus(false);
        onBlur && onBlur();
    }, [onBlur]);
    var handleFocus = React__default.useCallback(function () {
        if (!disabled) {
            setHasFocus(true);
        }
    }, [disabled]);
    React__default.useCallback(function () { return !disabled && setHasFocus(function (current) { return !current; }); }, [
        disabled,
    ]);
    var handleChange = React__default.useCallback(function (date) {
        setDate(date || undefined);
        !isTouched && setIsTouched(true);
    }, [isTouched]);
    var onNativeChange = React__default.useCallback(function (e) {
        if (!e.target.value) {
            /*
             * Clearing the input is not supported by the current interfaces,
             * fallback to the current value. This shouldn't happen since
             * we hide the clear button with css as well.
             */
            e.target.value = date && DateUtils.toLocalDate(date);
            return;
        }
        handleChange(new Date(e.target.value));
    }, [handleChange]);
    React__default.useEffect(function () {
        if (date && isValid(date)) {
            onChange(date);
            setHasFocus(false);
            isTouched && setIsValid(true);
        }
        else if (required) {
            isTouched && setIsValid(false);
        }
    }, [date, onChange, required, isTouched]);
    return (React__default.createElement("div", { className: classnames('form-control date-picker', className, {
            'date-picker--focus': hasFocus,
            'date-picker--disabled': disabled,
        }), "data-t": testId },
        label && (React__default.createElement("label", { className: "form-control__label" },
            label,
            required && !hideAsteriskSign && React__default.createElement("span", { className: "form-control__asterisk" }, "*"),
            tooltip && React__default.createElement(Tooltip, { message: tooltip, id: "date-picker-tooltip" }))),
        !required && optionalText && (React__default.createElement("small", { className: "form-control__optional-tag" }, optionalText)),
        React__default.createElement("div", { className: "date-picker__input-container", role: "button", onClick: handleFocus },
            React__default.createElement(Icon, { name: "calendar" }),
            useNativeInput ? (React__default.createElement("input", { type: "date", className: classnames('form-control__input', 'date-picker__input', 'date-picker__input--native', {
                    _is_invalid: !isValid$1,
                }), value: date && DateUtils.toLocalDate(date), min: minDate && DateUtils.toLocalDate(minDate), max: maxDate && DateUtils.toLocalDate(maxDate), onChange: onNativeChange, onBlur: handleBlur, disabled: disabled, required: required, "aria-required": required, "aria-label": "Pick your date" })) : (dateFnsLocale && (React__default.createElement(ReactDatePicker, { dateFnsLocale: dateFnsLocale, className: classnames('form-control__input', 'date-picker__input', {
                    _is_invalid: !isValid$1,
                }), selected: date, onChange: handleChange, onBlur: handleBlur, placeholderText: placeholder, dateFormat: dateFormat, locale: locale, minDate: minDate, maxDate: maxDate, disabled: disabled, renderCustomHeader: customHeader, customInput: React__default.createElement("input", { placeholder: placeholder, "aria-label": "Pick your date" }) }))),
            React__default.createElement(Icon, { name: "chevron-down" })),
        errorMessage && !isValid$1 && React__default.createElement("span", { className: "form-control__error" }, errorMessage)));
};

var RangeDatePicker = function (_a) {
    var labelStart = _a.labelStart, labelEnd = _a.labelEnd, tooltip = _a.tooltip, onSelectStartDate = _a.onSelectStartDate, onSelectEndDate = _a.onSelectEndDate, startDate = _a.startDate, endDate = _a.endDate, startDatePlaceholder = _a.startDatePlaceholder, endDatePlaceholder = _a.endDatePlaceholder, _b = _a.required, required = _b === void 0 ? true : _b, _c = _a.dateFormat, dateFormat = _c === void 0 ? 'MMMM d, yyyy' : _c, _d = _a.maxRangeWeeks, maxRangeWeeks = _d === void 0 ? 2 : _d, _e = _a.hideAsteriskSign, hideAsteriskSign = _e === void 0 ? false : _e, _f = _a.useNativeInput, useNativeInput = _f === void 0 ? false : _f, _g = _a.today, today = _g === void 0 ? new Date() : _g, className = _a.className, rest = __rest(_a, ["labelStart", "labelEnd", "tooltip", "onSelectStartDate", "onSelectEndDate", "startDate", "endDate", "startDatePlaceholder", "endDatePlaceholder", "required", "dateFormat", "maxRangeWeeks", "hideAsteriskSign", "useNativeInput", "today", "className"]);
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('range-date-picker', { 'range-date-picker--with-end-label': Boolean(labelEnd) }, className) }),
        React__default.createElement(DatePicker, { key: "start-" + Date.now(), className: "date-picker--start", label: labelStart, tooltip: tooltip, required: required, onChange: onSelectStartDate, placeholder: startDatePlaceholder, dateFormat: dateFormat, initialValue: startDate, minDate: today, maxDate: DateUtils.shiftDate(today, 'week', maxRangeWeeks), hideAsteriskSign: hideAsteriskSign, useNativeInput: useNativeInput }),
        React__default.createElement(DatePicker, { key: "end-" + Date.now(), className: "date-picker--end", label: labelEnd, onChange: onSelectEndDate, required: required, placeholder: endDatePlaceholder, initialValue: endDate, minDate: today, maxDate: DateUtils.shiftDate(today, 'week', maxRangeWeeks), dateFormat: dateFormat, hideAsteriskSign: hideAsteriskSign, useNativeInput: useNativeInput })));
};

var RequiredFieldsLabel = function (_a) {
    var className = _a.className;
    var getLabel = useIntl().getLabel;
    return (React.createElement("div", { className: classnames('required-fields', className) },
        React.createElement("span", { className: "required-fields__asterisk" }, "*"),
        React.createElement("div", { className: "required-fields__label" }, getLabel('common.form.field.required'))));
};

var RecaptchaContext = React__default.createContext({});
var RecaptchaProvider = function (_a) {
    var children = _a.children, settings = _a.settings;
    var context = {
        settings: settings,
    };
    return React__default.createElement(RecaptchaContext.Provider, { value: context }, children);
};

var useRecaptchaContext = function () { return React__default.useContext(RecaptchaContext); };
var RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js';
var useRecaptcha = function (options) {
    var settings = useRecaptchaContext().settings;
    React__default.useEffect(function () {
        if (!settings) {
            return;
        }
        var script = createScriptTag({
            async: true,
            src: RECAPTCHA_SCRIPT_SRC + "?render=" + settings.siteKey,
        });
        injectTags([script]);
    }, [settings]);
    var handleRecaptcha = React__default.useCallback(function (cb) {
        if (typeof window.grecaptcha === 'undefined') {
            console.error('Recaptcha not correctly initialised.');
            return;
        }
        window.grecaptcha.ready(function () {
            var action = (options === null || options === void 0 ? void 0 : options.action) || 'form';
            window.grecaptcha.execute(settings.siteKey, { action: action }).then(function (token) {
                cb(token);
            });
        });
    }, []);
    return [{ handleRecaptcha: handleRecaptcha }];
};

var AddressLine = function (_a) {
    var _b = _a.count, count = _b === void 0 ? '1' : _b, label = _a.label, errorMessage = _a.errorMessage, _c = _a.validations, validations = _c === void 0 ? [isAlphanumeric] : _c, rest = __rest(_a, ["count", "label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "addressLine" + count, "data-t": "address-line-" + count, label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var City = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isText] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "city", "data-t": "city", type: "text", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var ContactMethod = function (_a) {
    var name = _a.name, className = _a.className, _b = _a.labels, label = _b.label, tooltip = _b.tooltip, error = _b.error, options = _a.options, value = _a.value, isTouched = _a.isTouched, isValid = _a.isValid, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.hideAsteriskSign, hideAsteriskSign = _d === void 0 ? false : _d, onChange = _a.onChange, rest = __rest(_a, ["name", "className", "labels", "options", "value", "isTouched", "isValid", "required", "hideAsteriskSign", "onChange"]);
    return (React.createElement("div", __assign({}, rest, { className: classnames('form-control contact-method', className) }),
        React.createElement("div", { className: "form-control__label" },
            label,
            required && !hideAsteriskSign && React.createElement("span", { className: "form-control__asterisk" }, "*"),
            tooltip && React.createElement(Tooltip, { id: name + "-tooltip", message: tooltip })),
        React.createElement("div", { className: "form-control__wrapper" },
            React.createElement(ConnectedRadioButtons, { className: className, alignment: "vertical", scope: name, items: options, initialValue: value, onChange: onChange })),
        !isValid && isTouched && error && React.createElement("span", { className: "form-control__error" }, error)));
};

/*
 * This wrapper can only be used in conjunction with ComposedForm. If a version is needed that also
 * works with Form (and without ComposedForm), this component needs to be expanded, or duplicated
 * for that puprose.
 */
var ContactMethodInput = function (_a) {
    var _b;
    var forScope = _a.forScope, forValues = _a.forValues, children = _a.children, _c = _a.forContactMethodName, forContactMethodName = _c === void 0 ? 'contactMethod' : _c;
    var values = Array.isArray(forValues) ? forValues : [forValues];
    var composedFormContext = React.useContext(ComposedFormContext);
    var getInitialState = composedFormContext.getInitialState;
    var formState = getInitialState && getInitialState(forScope);
    var contactMethodValue = (_b = formState === null || formState === void 0 ? void 0 : formState[forContactMethodName]) === null || _b === void 0 ? void 0 : _b.value;
    var required = contactMethodValue !== undefined && values.includes(contactMethodValue);
    return children({ required: required });
};

var NAME = 'contactMethod';
var ContactMethodContainer = function (_a) {
    var _b;
    var className = _a.className, name = _a.name, labels = _a.labels, options = _a.options, initialState = _a.initialState, _c = _a.required, required = _c === void 0 ? false : _c, onChange = _a.onChange, rest = __rest(_a, ["className", "name", "labels", "options", "initialState", "required", "onChange"]);
    var _d = __read(React.useState((initialState === null || initialState === void 0 ? void 0 : initialState.value) || ((_b = options.find(function (entry) { return entry.isDefault; })) === null || _b === void 0 ? void 0 : _b.value) || ''), 2), value = _d[0], setValue = _d[1];
    var _e = __read(React.useState((initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || false), 2), isTouched = _e[0], setIsTouched = _e[1];
    var readonly = (initialState === null || initialState === void 0 ? void 0 : initialState.readonly) || false;
    var formattedOptions = React.useMemo(function () {
        return options.map(function (_a) {
            _a.isDefault; var rest = __rest(_a, ["isDefault"]);
            return (__assign(__assign({}, rest), { disabled: readonly }));
        });
    }, [options, readonly]);
    var isValid = React.useMemo(function () {
        return FormControl.validate([], required, value);
    }, [required, value]);
    var onChangeHandler = React.useCallback(function (formControlState) {
        setIsTouched(true);
        setValue(formControlState.value);
        onChange && onChange(formControlState);
    }, [onChange, setIsTouched, setValue]);
    React.useEffect(function () {
        setIsTouched((initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || false);
    }, [initialState === null || initialState === void 0 ? void 0 : initialState.isTouched]);
    React.useEffect(function () {
        if (initialState) {
            setValue(initialState.value);
        }
    }, [initialState === null || initialState === void 0 ? void 0 : initialState.value]);
    return (React.createElement(ContactMethod, __assign({ name: name || NAME, className: className, labels: labels, options: formattedOptions, value: value, isTouched: isTouched, isValid: isValid, onChange: onChangeHandler, required: required }, rest)));
};
var ConnectedContactMethodContainer = function (_a) {
    var name = _a.name, onChange = _a.onChange, initialState = _a.initialState, rest = __rest(_a, ["name", "onChange", "initialState"]);
    return (React.createElement(FormContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        return (React.createElement(ContactMethodContainer, __assign({}, rest, { name: name, onChange: context.onChange || onChange, initialState: context.getInitialState ? context.getInitialState(name || NAME) : initialState })));
    }));
};
ConnectedContactMethodContainer.Input = ContactMethodInput;

var Email = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'email' : _b, _c = _a["data-t"], dataT = _c === void 0 ? 'email' : _c, label = _a.label, errorMessage = _a.errorMessage, _d = _a.validations, validations = _d === void 0 ? [isEmailAddress] : _d, rest = __rest(_a, ["id", 'data-t', "label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: id, "data-t": dataT, type: "email", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var FirstName = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isText] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "firstName", "data-t": "first-name", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var MiddleName = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage; _a.validations; var rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "middleName", "data-t": "middle-name", label: label, errorMessage: errorMessage }, rest)));
};

var LastName = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isText] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "lastName", "data-t": "last-name", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var HouseNumber = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isNotDecimalNumber] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "streetNumber", "data-t": "house-number", type: "text", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var HouseNumberSuffix = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, rest = __rest(_a, ["label", "errorMessage"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "additionalStreetInfo", "data-t": "house-number-suffix", label: label, errorMessage: errorMessage }, rest)));
};

var ToggleIcon = function (_a) {
    var onClick = _a.onClick, className = _a.className, isActive = _a.isActive, isDisabled = _a.isDisabled;
    var getLabel = useIntl().getLabel;
    return (React.createElement("button", { type: "button", "aria-label": isActive ? getLabel('account.hidePassword') : getLabel('account.showPassword'), onClick: onClick, disabled: isDisabled, className: className }, isActive ? React.createElement(Icon, { name: "eye-slash" }) : React.createElement(Icon, { name: "eye" })));
};
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            passwordVisible: false,
        };
        _this.onVisibilityToggle = function () {
            _this.setState(function (prevState) { return ({
                passwordVisible: !prevState.passwordVisible,
            }); });
        };
        return _this;
    }
    Password.prototype.render = function () {
        var _a = this.props, label = _a.label, errorMessage = _a.errorMessage, rest = __rest(_a, ["label", "errorMessage"]);
        var passwordVisible = this.state.passwordVisible;
        return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "password", "data-t": "password", "aria-describedby": rest['aria-describedby'], type: passwordVisible ? 'text' : 'password', label: label, className: "form-control--password", icon: React.createElement(ToggleIcon, { onClick: this.onVisibilityToggle, className: "password-toggle", isActive: passwordVisible }), errorMessage: errorMessage }, rest)));
    };
    Password.defaultProps = {
        required: true,
        validations: [],
    };
    return Password;
}(React.Component));

/* OWASP Special Characters: https://www.owasp.org/index.php/Password_special_characters */
var specialCharacters = [
    ' ',
    '!',
    '"',
    '#',
    '\\$',
    '%',
    '&',
    "'",
    '\\(',
    '\\)',
    '\\*',
    '\\+',
    ',',
    '-',
    '\\.',
    '/',
    ':',
    ';',
    '<',
    '=',
    '>',
    '\\?',
    '@',
    '\\[',
    '\\\\',
    '\\]',
    '\\^',
    '_',
    '`',
    '{',
    '\\|',
    '}',
    '~',
].join('|');
var minLength = function (password, amount) { return password.length >= amount; };
var containsLowercase = /[a-z]/;
var containsUppercase = /[A-Z]/;
var containsNumber = /[0-9]/;
var noTripleCharacters = /^(?:(.)\1?(?!\1))+$/;
var numberOfSpecialCharacters = function (amount) {
    return new RegExp(specialCharacters + "{" + amount + "}");
};
// There must be three out of these four character types: lowercase, uppercase, number, symbol
var minRequiredCharacterTypes = 3;
var characterTypeRules = [
    containsLowercase,
    containsUppercase,
    containsNumber,
    numberOfSpecialCharacters(1),
];
function isModerate(password) {
    // Moderate
    /**
     * At least 6 characters including 3 out of the following types:
     * - a lowercase letter
     * - an uppercase letter
     * - a number
     * - a special character (such as !@#$%^&*, see OWASP special characters at the top of this file)
     */
    var rulesPassed = characterTypeRules.filter(function (rule) { return rule.test(password); });
    return minLength(password, 6) && rulesPassed.length >= minRequiredCharacterTypes;
}
function isStrong(password) {
    // Strong
    /**
     * At least 8 characters including 3 out of the following types:
     * - a lowercase letter
     * - an uppercase letter
     * - a number
     * - a special character (such as !@#$%^&*, see OWASP special characters at the top of this file)
     */
    var rulesPassed = characterTypeRules.filter(function (rule) { return rule.test(password); });
    return minLength(password, 8) && rulesPassed.length >= minRequiredCharacterTypes;
}
function isExcellent(password) {
    // Excellent
    /**
     * At least 10 characters including 3 out of the following types:
     * - a lower-case letter
     * - an upper-case letter
     * - a number
     * - a special character (such as !@#$%^&*, see OWASP special characters at the top of this file)
     *
     * Not more than 2 identical characters in a row (e.g. 555 is not allowed)
     */
    var rulesPassed = characterTypeRules.filter(function (rule) { return rule.test(password); });
    var passedNoTripleCharacters = noTripleCharacters.test(password);
    return (minLength(password, 10) &&
        passedNoTripleCharacters &&
        rulesPassed.length >= minRequiredCharacterTypes);
}
function isWeak(password) {
    return !isModerate(password) && !isStrong(password) && !isExcellent(password);
}
function getPasswordStrength(password) {
    var measurements = [
        ['weak', isWeak(password)],
        ['moderate', isModerate(password)],
        ['strong', isStrong(password)],
        ['excellent', isExcellent(password)],
    ];
    return measurements.reduce(function (strength, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return (value ? key : strength);
    }, 'weak');
}

var PasswordWithStrengthIndicator = function (_a) {
    var value = _a.value, _b = _a.indicatorPosition, indicatorPosition = _b === void 0 ? 'bottom' : _b, className = _a.className, rest = __rest(_a, ["value", "indicatorPosition", "className"]);
    var getLabel = useIntl().getLabel;
    var strength = getPasswordStrength(value);
    return (React.createElement("div", { "data-t": "password-with-strength-indicator", className: classnames('password-with-strength-indicator', "password-with-strength-indicator--position-" + indicatorPosition, { 'password-with-strength-indicator--with-label': rest.label }, className) },
        React.createElement(Password, __assign({}, rest, { "aria-describedby": "strength-indicator" })),
        React.createElement("div", { id: "strength-indicator", className: classnames('password-with-strength-indicator__indicator', className) },
            React.createElement("p", { className: "password-with-strength-indicator__title" },
                React.createElement("span", null,
                    getLabel('account.passwordStrength'),
                    ': '),
                React.createElement("span", { className: "password-with-strength-indicator__strength password-with-strength-indicator__strength--" + strength }, getLabel("account.passwordStrength." + strength))),
            React.createElement("p", { className: "password-with-strength-indicator__message" }, getLabel("account.passwordStrength." + strength + ".hint")),
            React.createElement("div", { className: "password-with-strength-indicator__tooltip-arrow" },
                React.createElement("svg", { className: "tooltip-arrow__icon", viewBox: "0 0 120 160" },
                    React.createElement("path", { className: "tooltip-arrow__path", d: "M 20,80 150,20 150,140 Z" }))))));
};

var PhoneNumber = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, rest = __rest(_a, ["label", "errorMessage"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "phone", "data-t": "phone-number", type: "tel", label: label, errorMessage: errorMessage }, rest)));
};

var PostalCode = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, rest = __rest(_a, ["label", "errorMessage"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "postalCode", "data-t": "postal-code", label: label, errorMessage: errorMessage }, rest)));
};

var Prefix = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "prefix", "data-t": "prefix", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var Region = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isText] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "region", "data-t": "region", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var Street = function (_a) {
    var label = _a.label, errorMessage = _a.errorMessage, _b = _a.validations, validations = _b === void 0 ? [isRequired] : _b, rest = __rest(_a, ["label", "errorMessage", "validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { id: "streetName", "data-t": "street", label: label, errorMessage: errorMessage, validations: validations }, rest)));
};

var JoinedFormFields = /** @class */ (function (_super) {
    __extends(JoinedFormFields, _super);
    function JoinedFormFields(props) {
        var _this = _super.call(this, props) || this;
        _this.isInitialized = false;
        _this.updateFields = function (fields) {
            var onChange = _this.props.onChange;
            _this.setState({ fields: fields }, function () {
                onChange && onChange(_this.state);
                _this.isInitialized = true;
            });
        };
        _this.updateFieldsState = function (name, fields, nextState) {
            var _a;
            if (fields === void 0) { fields = {}; }
            if (nextState === void 0) { nextState = {}; }
            return {
                fields: __assign(__assign({}, fields), (_a = {}, _a[name] = __assign(__assign({}, fields[name]), nextState), _a)),
            };
        };
        _this.handleChange = function (formControlState, name) {
            var _a = _this.props, joinValue = _a.joinValue, validate = _a.validate, onChange = _a.onChange;
            _this.setState(function (_a) {
                var fields = _a.fields;
                var fieldsStateUpdate = _this.updateFieldsState(name, fields, formControlState);
                var isValid = validate(fieldsStateUpdate.fields);
                var value = isValid ? joinValue(fieldsStateUpdate.fields) : '';
                return __assign(__assign({}, fieldsStateUpdate), { value: value,
                    isValid: isValid });
            }, function () { return onChange && onChange(_this.state); });
        };
        _this.handleBlur = function (name) {
            var onChange = _this.props.onChange;
            _this.isInitialized = true;
            _this.setState(function (_a) {
                var fields = _a.fields;
                return (__assign(__assign({}, _this.updateFieldsState(name, fields, { isTouched: true })), { isTouched: true }));
            }, function () { return onChange && onChange(_this.state); });
        };
        var initialState = props.initialState, name = props.name;
        _this.state = {
            fields: {},
            isTouched: initialState && initialState.isTouched,
            isValid: initialState && initialState.isValid,
            name: name,
            value: initialState ? initialState.value : '',
        };
        return _this;
    }
    JoinedFormFields.prototype.componentDidUpdate = function (_a, _b) {
        var initialState = _a.initialState, initializeStateFields = _a.initializeStateFields, validate = _a.validate;
        _b.value; var fields = _b.fields;
        // Getting the new initial state
        var newInitialState = (this.props.initialState && this.props.initialState.value) || '';
        if (!this.isInitialized ||
            (initialState && newInitialState && initialState.value !== newInitialState)) {
            // (Re)initialize when it is not already initialized or when the props.initialState changes
            var nextFields = initializeStateFields(newInitialState);
            if (nextFields !== fields && validate(nextFields)) {
                this.updateFields(nextFields);
            }
        }
    };
    JoinedFormFields.prototype.componentDidMount = function () {
        var _a = this.props, initializeStateFields = _a.initializeStateFields; _a.validate;
        var value = this.state.value;
        var fields = initializeStateFields(value);
        this.updateFields(fields);
    };
    JoinedFormFields.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, fieldColumns = _a.fieldColumns, label = _a.label, tooltipText = _a.tooltipText, className = _a.className, children = _a.children, errorMessage = _a.errorMessage;
        var _b = this.state, fields = _b.fields, isValid = _b.isValid, isTouched = _b.isTouched;
        var cssClasses = classnames('joined-form-fields form-group--columns', className, {
            _is_invalid: isTouched && !isValid,
            'joined-form-fields--label': label !== undefined,
        });
        return (React.createElement(FormGroup, { columns: fieldColumns, className: cssClasses },
            label && (React.createElement("div", { className: "joined-form-fields__label" },
                React.createElement("span", null, label),
                tooltipText && React.createElement(Tooltip, { id: "t_" + name, message: tooltipText }))),
            React.Children.map(children, function (child) {
                if (typeof child === 'number' ||
                    typeof child === 'string' ||
                    !React.isValidElement(child)) {
                    return child;
                }
                var id = child.props.id;
                return (React.createElement("label", { className: "form-control" },
                    React.createElement("span", { className: "form-control__label" }, id),
                    React.createElement("div", { className: "form-control__wrapper" }, React.cloneElement(child, {
                        key: id,
                        initialState: fields && id ? fields[id] : {},
                        initialValue: fields && id && fields[id] ? fields[id].value : '',
                        onBlur: function () { return id && _this.handleBlur(id); },
                        onChange: function (inputState) {
                            return id && _this.handleChange(inputState, id);
                        },
                    }))));
            }),
            isTouched && !isValid && React.createElement("span", { className: "joined-form-fields__error" }, errorMessage)));
    };
    JoinedFormFields.defaultProps = {
        required: false,
    };
    return JoinedFormFields;
}(React.Component));
var ConnectedJoinedFormFields = function (_a) {
    var onChange = _a.onChange, rest = __rest(_a, ["onChange"]);
    return (React.createElement(FormContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        return (React.createElement(JoinedFormFields, __assign({}, rest, { onChange: function (formControlState) {
                context.onChange && context.onChange(formControlState);
                onChange && onChange(formControlState);
            }, initialState: (context.getInitialState && context.getInitialState(rest.name)) ||
                (rest.initialState && rest.initialState) })));
    }));
};

/**
 * This component is messy and should be avoid for usage in new opcos (currently eyewish only).
 * If required in a new OpCo site, this component should be re-written completley.
 */
var DateOfBirth = /** @class */ (function (_super) {
    __extends(DateOfBirth, _super);
    function DateOfBirth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.fieldNames = ['dobDay', 'dobMonth', 'dobYear'];
        _this.hasFields = function (fields) {
            return _this.fieldNames.every(function (fieldName) { return fieldName in fields; });
        };
        _this.validateDateOfBirth = function (fields) {
            var hasEmptyField = Object.values(fields).find(function (field) { return field.value === ''; });
            if (hasEmptyField) {
                return false;
            }
            var dobDay = fields.dobDay && fields.dobDay.value;
            var dobMonth = fields.dobMonth && fields.dobMonth.value;
            var dobYear = fields.dobYear && fields.dobYear.value;
            return _this.hasFields(fields) && isValidBirthDate(dobDay, dobMonth, dobYear);
        };
        _this.zeroPrefix = function (val) { return val && val.padStart(2, '0'); };
        _this.joinDateOfBirth = function (fields) {
            if (!fields) {
                return '';
            }
            var dobDay = fields.dobDay ? fields.dobDay.value : '';
            var dobMonth = fields.dobMonth ? fields.dobMonth.value : '';
            var dobYear = fields.dobYear ? fields.dobYear.value : '';
            return "" + _this.zeroPrefix(dobDay) + _this.zeroPrefix(dobMonth) + dobYear;
        };
        _this.initializeDateFields = function (value) {
            var date = value && value.length ? value : '';
            return {
                dobDay: {
                    name: 'dobDay',
                    value: date.substr(0, 2),
                    isTouched: false,
                },
                dobMonth: {
                    name: 'dobMonth',
                    value: date.substr(2, 2),
                    isTouched: false,
                },
                dobYear: {
                    name: 'dobYear',
                    value: date.substr(4, 4),
                    isTouched: false,
                },
            };
        };
        _this.validateDay = function (value) {
            var _a = _this.state, dobMonth = _a.dobMonth, dobYear = _a.dobYear;
            var isTouched = dobMonth && dobMonth.isTouched && dobYear && dobYear.isTouched;
            var year = Number(dobYear && dobYear.value);
            var month = Number(dobMonth && dobMonth.value) - 1;
            var day = Number(value);
            var date = new Date(year, month, day);
            var isValidDate = date.getDate() === day;
            return isTouched ? isValidDate : isValidDay(value);
        };
        _this.applyClasses = function (name, validator) {
            return classnames('form-control__input', {
                _is_valid: name && validator(name.value) && name.isTouched === true,
                _is_invalid: name && !validator(name.value) && name.isTouched === true,
            });
        };
        _this.onFieldsChange = function (formFields) { return _this.setState(__assign({}, formFields.fields)); };
        return _this;
    }
    DateOfBirth.prototype.render = function () {
        var _a = this.props, name = _a.name, dateOfBirthLabel = _a.dateOfBirthLabel, tooltipLabel = _a.tooltipLabel, dayPlaceholder = _a.dayPlaceholder, monthPlaceholder = _a.monthPlaceholder, yearPlaceholder = _a.yearPlaceholder, errorMessage = _a.errorMessage;
        var _b = this.state, dobDay = _b.dobDay, dobMonth = _b.dobMonth, dobYear = _b.dobYear;
        return (React.createElement(ConnectedJoinedFormFields, { name: name, errorMessage: errorMessage, label: dateOfBirthLabel, tooltipText: tooltipLabel, fieldColumns: 3, required: true, validate: this.validateDateOfBirth, joinValue: this.joinDateOfBirth, initializeStateFields: this.initializeDateFields, onChange: this.onFieldsChange, initialState: {
                isValid: false,
                isTouched: false,
                value: '',
                name: name,
            } },
            React.createElement(Input, { id: "dobDay", "data-t": "dob-day", placeholder: dayPlaceholder, type: "number", min: DATES_RANGE.DAY.min, max: DATES_RANGE.DAY.max, className: this.applyClasses(dobDay, this.validateDay) }),
            React.createElement(Input, { id: "dobMonth", "data-t": "dob-month", type: "number", placeholder: monthPlaceholder, min: DATES_RANGE.MONTH.min, max: DATES_RANGE.MONTH.max, className: this.applyClasses(dobMonth, isValidMonth) }),
            React.createElement(Input, { id: "dobYear", "data-t": "dob-year", type: "number", placeholder: yearPlaceholder, min: DATES_RANGE.YEAR_OF_BIRTH.min, max: DATES_RANGE.YEAR_OF_BIRTH.max, className: this.applyClasses(dobYear, isValidBirthDateYear) })));
    };
    return DateOfBirth;
}(React.Component));

var Number$1 = function (_a) {
    var _b = _a.validations, validations = _b === void 0 ? [isNumber] : _b, rest = __rest(_a, ["validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { validations: validations }, rest)));
};

var Text = function (_a) {
    var _b = _a.validations, validations = _b === void 0 ? [isText] : _b, rest = __rest(_a, ["validations"]);
    return (React.createElement(ConnectedFormControl, __assign({}, ConnectedFormControl.defaultProps, { validations: validations }, rest)));
};

export { AddressLine, BookAppointment, City, ComposedForm, ConnectedRadioButtons, ConnectedContactMethodContainer as ContactMethod, DateOfBirth, ConnectedDateOfBirthSelect as DateOfBirthSelect, DatePicker, DiscountCodeForm, Email, Field, FirstName, Form, ConnectedFormControl as FormControl, FormGroup, types as FormTypes, HouseNumber, HouseNumberSuffix, Input, InputWithSuggestions, LastName, MiddleName, ConnectedMultipleAddressLine as MultipleAddressLine, Number$1 as Number, Password, PasswordWithStrengthIndicator, PhoneNumber, PostalCode, Prefix, ConnectedPrefixSelect as PrefixSelect, RadioButtons, RangeDatePicker, RecaptchaContext, RecaptchaProvider, Region, RequiredFieldsLabel, Select, Street, Text, TextArea, index as Util, useRecaptcha };
//# sourceMappingURL=index.es.js.map
